// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "qliq_protobuf/auth/user.proto" (package "qliq_protobuf.auth", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { UserType } from "../user_type";
import { Avatar } from "../avatar";
/**
 * @generated from protobuf message qliq_protobuf.auth.User
 */
export interface User {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: uint32 qliq_id = 2;
     */
    qliqId: number;
    /**
     * @generated from protobuf field: uint32 chat_user_id = 3;
     */
    chatUserId: number;
    /**
     * @generated from protobuf field: string email = 4;
     */
    email: string;
    /**
     * @generated from protobuf field: string first_name = 5;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string middle_name = 6;
     */
    middleName: string;
    /**
     * @generated from protobuf field: string last_name = 7;
     */
    lastName: string;
    /**
     * @generated from protobuf field: string title = 8;
     */
    title: string;
    /**
     * @generated from protobuf field: string mobile_number = 9;
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string status = 10;
     */
    status: string;
    /**
     * @generated from protobuf field: bool is_setup_completed = 11;
     */
    isSetupCompleted: boolean;
    /**
     * @generated from protobuf field: string organization_name = 12;
     */
    organizationName: string;
    /**
     * @generated from protobuf field: qliq_protobuf.Avatar avatar = 13;
     */
    avatar?: Avatar;
    /**
     * @generated from protobuf field: string presence_status = 14;
     */
    presenceStatus: string;
    /**
     * @generated from protobuf field: string presence_message = 15;
     */
    presenceMessage: string;
    /**
     * @generated from protobuf field: string forwarding_qliq_id = 16;
     */
    forwardingQliqId: string;
    /**
     * @generated from protobuf field: qliq_protobuf.UserType type = 17;
     */
    type: UserType;
}
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType<User> {
    constructor() {
        super("qliq_protobuf.auth.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "qliq_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "chat_user_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "middle_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "mobile_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "is_setup_completed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "avatar", kind: "message", T: () => Avatar },
            { no: 14, name: "presence_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "presence_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "forwarding_qliq_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "type", kind: "enum", T: () => ["qliq_protobuf.UserType", UserType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message qliq_protobuf.auth.User
 */
export const User = new User$Type();
